import { render, staticRenderFns } from "./detailDri.vue?vue&type=template&id=7ae6f61e&scoped=true"
import script from "./detailDri.vue?vue&type=script&lang=js"
export * from "./detailDri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae6f61e",
  null
  
)

export default component.exports